import { render, staticRenderFns } from "./user_credit_count.vue?vue&type=template&id=c1320a5a&"
import script from "./user_credit_count.vue?vue&type=script&lang=ts&"
export * from "./user_credit_count.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports